'use strict';

import Api from "./Api";

export default class Schedule extends Api {

    static getDay(filiationId, startDate, endDate = undefined) {
        const url = this.url + 'schedule/days';

        return this.getAxios().get(url, {
            params: {
                filiation_id: filiationId,
                date: startDate,
                date_end: !endDate ? startDate : endDate
            },
        });
    }

    static get(id) {
        const url = this.url + 'schedule/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'schedule/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'schedule/update';

        return this.getAxios().post(url, data);
    }

    static updateTime(data) {
        const url = this.url + 'schedule/update-time';

        return this.getAxios().post(url, data);
    }

    static remove(data) {
        const url = this.url + 'schedule/remove';

        return this.getAxios().post(url, data);
    }
}